import styled from 'styled-components'

import CDeclarationBlock from '../../components/DeclarationBlock'
import breakpoints from '../../theme/breakpoints'
import ActionButton from '../../components/ActionButton'
import CBoxedContent from '../../components/BoxedContent'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
`

export const BoxedContent = styled(CBoxedContent)`
  padding: 0 1.6rem;
`

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 4rem;

  ${breakpoints.up('tablet')} {
    flex-direction: row;
    margin-top: 6rem;
  }
`

export const UserInfoItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 1.6rem;

  ${breakpoints.up('tablet')} {
    margin-bottom: 0;
    margin-right: 4rem;
  }
`

export const UserInfoTitle = styled.div`
  ${({ theme }) => theme.textStyles.textLargeStrong};
  color: ${({ theme }) => theme.colors.nightRider};
  margin-right: 1rem;
`

export const UserInfoValue = styled.div`
  ${({ theme }) => theme.textStyles.textLarge};
  color: ${({ theme }) => theme.colors.nightRider};
`

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  margin: 4rem 0;

  ${breakpoints.up('tablet')} {
    flex-direction: row;
  }
`

export const Action = styled(ActionButton)`
  width: max-content;
  max-width: 220px;
`

export const DeclarationBlock = styled(CDeclarationBlock)`
  margin-bottom: 4rem;
`

export const Message = styled.p`
  ${({ theme }) => theme.textStyles.H3};
  text-align: center;
  margin-top: 5rem;
  margin-bottom: 5rem;
  display: block;
`

export const Error = styled.p`
  ${({ theme }) => theme.textStyles.H3};
  text-align: center;
  margin-top: 5rem;
  margin-bottom: 5rem;
  display: block;
  color: red;
`
